
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.813 2.406L8.907 4.5 7.501 5.906 5.407 3.812zm18.375 0l1.406 1.406L24.5 5.906 23.094 4.5zM16 3.031c4.934-.047 9 4.027 9 8.969 0 2.706-1.249 5.062-2.906 6.719-1.238 1.15-2 2.627-2 4.094v1.188H20v4h-2.281c-.347.597-.982 1-1.719 1s-1.372-.403-1.719-1H12v-6a5.244 5.244 0 00-1.75-3.031c-2.233-1.898-3.573-4.845-3.125-8.094.561-4.039 3.789-7.316 7.844-7.781H15a9.178 9.178 0 011-.063zm0 2c-.258.004-.518.03-.781.063-3.131.348-5.687 2.881-6.125 6.031-.352 2.552.702 4.811 2.469 6.313 1.388 1.19 2.124 2.848 2.344 4.563h4.375c.236-1.792 1.094-3.434 2.438-4.688l-.031-.031c1.343-1.343 2.313-3.187 2.313-5.281 0-3.861-3.135-7.024-7-6.969zM2 12h3v2H2v-2zm25 0h3v2h-3v-2zM7.5 20.094L8.906 21.5l-2.094 2.094-1.406-1.406zm17 0l2.094 2.094-1.406 1.406-2.094-2.094zM14 24v2h4v-2h-4z"}})])
          )
        }
      }
    